import React, { useState, useEffect } from 'react';
import API from '../api';
import { RefreshCw } from 'lucide-react';

const fmtEur = v => (v ?? 0).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
const fmtN = v => (v ?? 0).toLocaleString('it-IT');

const Kpi = ({ titolo, valore, sub, colore = '#2E75B6' }) => (
  <div style={{ background: 'white', border: '1px solid #e8eaed', borderRadius: 10,
    padding: '16px 18px', borderTop: `3px solid ${colore}` }}>
    <div style={{ fontSize: 11, color: '#718096', textTransform: 'uppercase',
      letterSpacing: '0.6px', marginBottom: 6 }}>{titolo}</div>
    <div style={{ fontSize: 26, fontWeight: 700, color: '#1A1A2E' }}>{valore}</div>
    {sub && <div style={{ fontSize: 12, color: '#a0aec0', marginTop: 4 }}>{sub}</div>}
  </div>
);

export default function Report() {
  const [dati, setDati] = useState(null);
  const [carico, setCarico] = useState(false);
  const [errore, setErrore] = useState(null);
  const [aggiornato, setAggiornato] = useState(null);

  const carica = async () => {
    setCarico(true); setErrore(null);
    try {
      const r = await API.get('/finanziario/report/carta-docente');
      setDati(r.data);
      setAggiornato(new Date());
    } catch (e) {
      setErrore('Errore nel caricamento del report.');
    } finally {
      setCarico(false);
    }
  };

  useEffect(() => { carica(); }, []);

  return (
    <div style={{ padding: 24, maxWidth: 1100 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1A1A2E', margin: 0 }}>
          Report — Carta Docente e Ottemperanze
        </h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {aggiornato && <span style={{ fontSize: 12, color: '#a0aec0' }}>
            Aggiornato: {aggiornato.toLocaleString('it-IT')}</span>}
          <button onClick={carica} disabled={carico}
            style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '8px 14px',
              borderRadius: 8, border: '1px solid #dde1e7', background: 'white',
              cursor: 'pointer', fontSize: 13 }}>
            <RefreshCw size={14} className={carico ? 'spin' : ''} /> Aggiorna
          </button>
        </div>
      </div>

      {errore && <div style={{ color: '#C53030', marginBottom: 16 }}>{errore}</div>}

      {dati && (
        <>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#718096', textTransform: 'uppercase',
            letterSpacing: '0.6px', margin: '8px 0 12px' }}>Pagamenti da incassare</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14, marginBottom: 28 }}>
            <Kpi titolo="Sentenze carta docente da pagare" valore={fmtEur(dati.sentenze_cd_da_pagare_eur)}
              sub={`${fmtN(dati.sentenze_cd_da_pagare_n)} sentenze`} colore="#276749" />
            <Kpi titolo="Sentenze in ottemperanza da pagare (tot)" valore={fmtEur(dati.sentenze_ott_tot_eur)}
              sub={`${fmtN(dati.sentenze_ott_tot_n)} sentenze`} colore="#2E75B6" />
            <Kpi titolo="— di cui ottemperanza carta (ricorrente)" valore={fmtEur(dati.sentenze_ott_carta_eur)}
              sub={`${fmtN(dati.sentenze_ott_carta_n)} sentenze`} colore="#5B9BD5" />
            <Kpi titolo="— di cui ottemperanza spese legali" valore={fmtEur(dati.sentenze_ott_spese_eur)}
              sub={`${fmtN(dati.sentenze_ott_spese_n)} sentenze`} colore="#8E44AD" />
          </div>

          <div style={{ fontSize: 13, fontWeight: 600, color: '#718096', textTransform: 'uppercase',
            letterSpacing: '0.6px', margin: '8px 0 12px' }}>Pendenze</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14 }}>
            <Kpi titolo="Ricorsi ottemperanza spese (Marone) pendenti" valore={fmtN(dati.ott_spese_pendenti)} colore="#E67E22" />
            <Kpi titolo="Ottemperanze non decise (pendenti)" valore={fmtN(dati.ott_non_decise)}
              sub={`di cui ${fmtN(dati.ott_non_decise_con_udienza)} con udienza fissata`} colore="#C0392B" />
            <Kpi titolo="Ricorsi carta docente non decisi" valore={fmtN(dati.cd_non_decisi)} colore="#16A085" />
            <Kpi titolo="Ottemperanze di ottemperanza pendenti" valore={fmtN(dati.ott_di_ott_pendenti)}
              sub={`${fmtN(dati.ott_di_ott_con_udienza)} con udienza · ${fmtN(dati.ott_di_ott_totali)} totali`} colore="#8E44AD" />
            <Kpi titolo="Appelli CdS pendenti" valore={fmtN(dati.appelli_cds_pendenti)}
              sub={`${fmtN(dati.appelli_cds_con_udienza)} con udienza · ${fmtN(dati.appelli_cds_totali)} totali`} colore="#D69E2E" />
            <Kpi titolo="Ottemperanze senza N.RG (da verificare)" valore={fmtN(dati.ott_senza_rg)}
              sub="Adesioni non perfezionate o RG mancante" colore="#A0AEC0" />
          </div>
        </>
      )}
    </div>
  );
}
